

/* ------------------------------------------------------------------
 * HOOK: useVacutainerLabelService
 * ------------------------------------------------------------------ */

import { useMutation, useQuery } from "@tanstack/react-query";
import { VacutainerLabelApiService } from "./vaccutainer.api";

export const useVacutainerLabelService = (payload?: {
    studyid?: number | null;
    period?: string | number | null;
    timepoint?: (string | number)[] | string | number | null;
    currentPage?: number;
    pageSize?: number;
    searchtext?: string;
}) => {

    // SELECT ALL QUERY (table data filtered by studyid)
    const SelectAllQuery = useQuery({
        queryKey: ["vacutainer-label-selectAll", payload?.studyid, payload?.period, payload?.timepoint, payload?.currentPage, payload?.pageSize, payload?.searchtext],
        queryFn: () => VacutainerLabelApiService.selectAll({
            studyid: payload?.studyid,
            period: payload?.period,
            timepoint: payload?.timepoint,
            currentpage: payload?.currentPage ?? null,
            pagesize: payload?.pageSize ?? null,
            searchtext: payload?.searchtext,
        }),
        enabled: !!(payload?.studyid && payload?.period && payload?.timepoint && (Array.isArray(payload.timepoint) ? payload.timepoint.length > 0 : true)),
    });

    // UPDATE PRINT MUTATION
    const UpdateLabelPrintMutation = useMutation({
        mutationFn: (mutPayload: any) => VacutainerLabelApiService.updateVacutainerLabel(mutPayload),
    });

    const InsertReprintHistoryMutation = useMutation({
        mutationFn: (payload: any) => VacutainerLabelApiService.insertVacutainerLabelhistory(payload),
    });

    return {
        SelectAllQuery,
        UpdateLabelPrintMutation,
        InsertReprintHistoryMutation,
    };
};